// © All right reserved to Equinom Ltd. © 2024.

import styled from '@emotion/styled'

export const TextsContainer = styled.div`
  display: flex;
  p {
    line-height: 20px;
    color: #4f4848;
    font-size: 20px;
  }
`

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
  text-decoration: none;
  color: #111;
`

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  height: 30px;
  /* TODO: get from the theme */
  color: #db3b3b;
`
